import { BREAK_TAG } from '../constants';

export default function replaceNewLinesWithBreakTags(str: string) {
  return str.replace(/\r\n|\n/g, BREAK_TAG);
}
